import { render, staticRenderFns } from "./LotesMain.vue?vue&type=template&id=59e878f3&scoped=true"
import script from "./LotesMain.vue?vue&type=script&lang=js"
export * from "./LotesMain.vue?vue&type=script&lang=js"
import style0 from "./LotesMain.vue?vue&type=style&index=0&id=59e878f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e878f3",
  null
  
)

export default component.exports